import type { ProviderKey } from "@versatile-credit-apply/omni-apply-client"

export const baseProviderPath = (providerKey: ProviderKey) =>
  `/providers/:providerKey(${providerKey}[^/]*)`
